const getDefaultState = () => {
    return {
        profile: [],
    };
};

// initial state
const state = getDefaultState();

const mutations = {
    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
    },
    SET_PROFILE(state, payload) {
        state.profile = payload;
    },
};

const actions = {
    resetState({ commit }) {
        commit('RESET_STATE');
    },
    setProfile({ commit }, payload) {
        commit('SET_PROFILE', payload);
    },
};

export default {
    state,
    getters: {
        getProfileIntimo(state) {
            return state.profile ? state.profile.user : "";
        },
        isIntimo(state) {
            return state.profile && state.profile.haveActiveSubscription ? true : false
        }
    },
    actions,
    mutations
};
